import { defineMessages, useIntl } from 'react-intl';
import { Accordion } from '@cbhq/cds-web/accordion/Accordion';
import { AccordionItem } from '@cbhq/cds-web/accordion/AccordionItem';
import { VStack } from '@cbhq/cds-web/layout';
import { Link, TextBody } from '@cbhq/cds-web/typography';

const HELP_URL = 'https://help.coinbase.com/en/commerce';
const SUMBIT_TICKET_URL = 'https://help.coinbase.com/en/contact-us?product=coinbase-commerce';

export const messages = defineMessages({
  faq1Question: {
    id: 'securityPhraseFaq1Question',
    defaultMessage: 'Where can I find my recovery phrase?',
    description: 'Question for FAQ item 1 for security phrase',
  },
  faq1Answer: {
    id: 'securityPhraseFaq1Answer',
    defaultMessage:
      'When you created your account, you were asked to store your secret recovery phrase somewhere safe. Popular options include writing it down on paper, saving it in a password manager, or storing in Google Drive.',
    description: 'Answer for FAQ item 1 for security phrase',
  },
  faq2Question: {
    id: 'securityPhraseFaq2Question',
    defaultMessage: "I can't find my recovery phrase. What do I do?",
    description: 'Question for FAQ item 2 for security phrase',
  },
  faq2Answer: {
    id: 'securityPhraseFaq2Answer',
    defaultMessage:
      "If you didn't save it, we're unable to recover it for you. Without your recovery phrase, there's no way to access your funds. Your funds belong entirely to you. No one, not even Coinbase, can access your funds without the secret recovery phrase.",
    description: 'Answer for FAQ item 2 for security phrase',
  },
  faq3Question: {
    id: 'securityPhraseFaq3Question',
    defaultMessage: 'Who do I contact if I run into issues?',
    description: 'Question for FAQ item 3 for security phrase',
  },
  faq3Answer: {
    id: 'securityPhraseFaq3Answer',
    defaultMessage:
      'Please visit our {help} to see if your question is already answered. If not, {submitTicket} and our team will do our best to assist you.',
    description: 'Answer for FAQ item 3 for security phrase',
  },
  helpCenter: {
    id: 'helpCenter',
    defaultMessage: 'Help Center',
    description: 'Label for the help center link',
  },
  submitTicket: {
    id: 'submitTicket',
    defaultMessage: 'submit a ticket',
    description: 'Label for the submit ticket link',
  },
});

export function SecurityPhraseFAQ() {
  const { formatMessage } = useIntl();
  return (
    <VStack>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq1Question.id}
          title={formatMessage(messages.faq1Question)}
        >
          <TextBody as="p">{formatMessage(messages.faq1Answer)}</TextBody>
        </AccordionItem>
      </Accordion>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq2Question.id}
          title={formatMessage(messages.faq2Question)}
        >
          <TextBody as="p">{formatMessage(messages.faq2Answer)}</TextBody>
        </AccordionItem>
      </Accordion>
      <Accordion>
        <AccordionItem
          itemKey={messages.faq3Question.id}
          title={formatMessage(messages.faq3Question)}
        >
          <TextBody as="p">
            {formatMessage(messages.faq3Answer, {
              help: (
                <Link href={HELP_URL} openInNewWindow>
                  {formatMessage(messages.helpCenter)}
                </Link>
              ),
              submitTicket: (
                <Link href={SUMBIT_TICKET_URL} openInNewWindow>
                  {formatMessage(messages.submitTicket)}
                </Link>
              ),
            })}
          </TextBody>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
